module.exports = __webpack_public_path__ + "public/SiteIcons/minusDecrementIcon.svg?128dfacd";